import { ExtraOptions, Routes } from '@angular/router';
import { HomeComponent } from './modules/components/home/home.component';
import { ProfileComponent } from './modules/components/profile/profile.component';
import { DetailsComponent } from './modules/components/details/details.component';
import { authGuard } from './guards/auth.guard';
import { LeaderboardComponent } from './modules/components/leaderboard/leaderboard.component';
import { LeaderboardDetailsComponent } from './modules/components/leaderboard-details/leaderboard-details.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { PortfolioComponent } from './modules/components/portfolio/portfolio.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { RewardsComponent } from './modules/components/rewards/rewards.component';
import { ActivityComponent } from './modules/components/activity/activity.component';
import { NotFoundComponent } from './modules/components/page-not-found/not-found.component';
import { LayoutComponent } from './layout/layout.component';
import { PrivacyPolicyComponent } from './modules/components/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './modules/components/terms-of-service/terms-of-service.component';

export const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authGuard]
    },
    {
        path: 'details/:slug',
        component: DetailsComponent
    },
    {
        path: 'leaderboard',
        component: LeaderboardComponent,
    },
    {
        path: 'leaderboard-details',
        component: LeaderboardDetailsComponent
    },
    {
        path: 'verify-email',
        component: VerifyEmailComponent
    },
    {
        path: 'callback',
        component: VerifyEmailComponent
    },
    {
        path: 'portfolio',
        component: PortfolioComponent
    },
    {
        path: 'rewards',
        component: RewardsComponent
    },
    {
            path: 'activity',
            component: ActivityComponent
        },
        {
            path: 'privacy-policy',
            component: PrivacyPolicyComponent
        },
        {
            path: 'terms-of-service',
            component: TermsOfServiceComponent
        }
    ],
},
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: "**",
        redirectTo: "/404"
    }
];


